module.exports = __webpack_public_path__ + "img/pkp.0631973d.jpeg";